import axios from 'axios'
import { BUSCAR_EMISSOES_CTE_OS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarEmissoesCteOS (empresaId, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina, filtros)

  const url = `${URL}/emissao-cte-os/empresa/${empresaId}${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_EMISSOES_CTE_OS,
        payload: response

      })
  );
}
